// extracted by mini-css-extract-plugin
export var portfolio = "articleText-module--portfolio--qO4NQ";
export var casestudy = "articleText-module--casestudy--RmFl2";